'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _shopgateLink = require('../../../../shopgate-link');

Object.defineProperty(exports, 'SGLink', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_shopgateLink).default;
  }
});
exports.sendDataRequest = sendDataRequest;
exports.hex2bin = hex2bin;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Sends a DataRequest
 * @param {string} url Url for the request
 */
function sendDataRequest(url) {
  $.shopgate.ajax({ url: 'sgapi:' + url });
}

/**
 * Converts a hex encoded string to a bin encoded string
 * @param {string} string hex encoded string
 * @return {string} formatted string
 */
function hex2bin(string) {
  return $.sgHelpers.hex2bin(string);
}

var SGAction = exports.SGAction = window.SGAction;



// WEBPACK FOOTER //
// ./Library/1.0/common/tracking/pwa-adapter/tracking-core/helpers/helper.js